import React, {Component} from 'react';
import BaseComponent, {contentParser} from "../../../../base/BaseComponent";
import {permissionCheck, uuid} from "../../../../utils";
import {Button, Dropdown, Icon, Menu, message} from "antd";

class NormalModal extends BaseComponent {

    refresh = (activiti, callBack=()=>{}) => {
        this.props.callBack && this.props.callBack();
        window.loading.hide();
        this.setState({visible:false,loadKeyByHide:uuid()});
    };

    convertBtn(btns) {
        try {
            contentParser(btns, {component: this});
        }catch (e) {
            // 这里try catch一下，暂时没有搞清楚为啥会出现属性成为只读的现象
        }
        btns && btns.map((item, index) => {
            if (item.extend) {//说明是扩展按钮 需要先转换
                let extend = item.extend;
                let regx = /^\$\{btnExtend\.([^.}]*)\}$/;
                if (regx.test(extend)) {
                    let btnExtendComponentName = extend.replace(regx, "$1");
                    try {
                        let btnExtendComponent = require(`../tableBtnExtend/${btnExtendComponentName}`).default;
                        let otherParams = JSON.parse(JSON.stringify(item.otherParams || {}));
                        let extendObj = btnExtendComponent({component: this, record: this.formData, ...otherParams});
                        if (typeof extendObj === "object") {
                            // delete item.extend;
                            // delete item.otherParams;
                            Object.assign(item, extendObj);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        });
    }

    buildFooterBtn(btns){
        let footer = [];
        btns && btns.map((item, index) => {
            // console.log(item)
            let otherParams = JSON.parse(JSON.stringify(item.otherParams || {}));
            let style = item.style || {};
            if(item.conditionFun) { //说明是函数调用结果
                let success = false;
                try {
                    let funParams = {conditionFun:item.conditionFun}
                    contentParser(funParams, {record: this.formData,window: window,that:this,});
                    let fn = eval(funParams.conditionFun);
                    if(fn()){
                        success = true;
                    }
                } catch(e) {
                    console.log(e.toString())
                }
                if (!success) {
                    return
                }
            }else if (item.condition) {//说明是看情况显示的
                if (item.condition.indexOf(this.formData.status) === -1) {//说明不满足条件
                    return;
                }
            }
            if (item.auth) {//校验当前用户是否有对应权限，如果有才能看到
                let auth = item.auth;
                if (!permissionCheck(auth)) {
                    return;
                }
            }
            // 修改状态按钮
            if (item.isModifyStatus) {
                const menu = (
                    <Menu>
                        {
                            item.btns.map((i, index) => {
                                return (
                                    <Menu.Item key={index}>
                                        <div onClick={() => {
                                            try {
                                                contentParser(otherParams, {record: this.formData});
                                                contentParser(otherParams, {otherData: this.otherData});
                                            } catch (e) {
                                                console.error(e)
                                            }
                                            i.onOk && i.onOk({
                                                component: this,
                                                record: this.formData, ...otherParams,
                                                btnInfo: item,
                                                currentBtn: i,
                                            });
                                        }}>{i.name}</div>
                                    </Menu.Item>
                                )
                            })
                        }
                    </Menu>
                );
                footer.push(
                        <Dropdown overlay={menu} placement="bottomLeft">
                            <Button type={"primary"}>
                                {item.name}
                                <Icon type="ellipsis" />
                            </Button>
                        </Dropdown>
                )
            } else {
                footer.push(
                    <Button key={index} type={item.type || ""} style={style} onClick={() => {
                        try {
                            contentParser(otherParams, {record: this.formData});
                            contentParser(otherParams, {otherData: this.otherData});
                        } catch (e) {
                            console.error(e)
                        }
                        item.onOk && item.onOk({component: this, record: this.formData, ...otherParams, btnInfo: item});
                    }}>{item.name}</Button>
                )
            }
        });
        return footer;
    }

}

export default NormalModal;
